import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(3),
  },
  container: {
    backgroundColor: theme.palette.background.paper,
  }
}));
